import ScreenLock from '../__constants/lock-screen';

const $ = jQuery.noConflict();

class StoreSlider {
    constructor(selector = '.store-products__slider') {
        this.selector = selector;
        this.selectedProduct = null;
        this.selectedDelivery = null;
        this.selectedStore = null;
        this.submitBtn = '.store-products__submit';
        this.heroBtn = '.js-hero-bottom-button';
    }

    init() {
        this.slider();
        this.storeSelector();
        this.submitBtnEvent();
        this.heroBtnEvent();
    }

    slider() {
        $(this.selector).on('init', (slick) => {
            const type = $(slick.target).attr('data-type');
            const activeItem = $(slick.target).find('.slick-current');
            this.changeValue(type, activeItem.attr('data-value'));
        });

        $(this.selector).on('afterChange', (slick) => {
            const type = $(slick.target).attr('data-type');
            const activeItem = $(slick.target).find('.slick-current');
            this.changeValue(type, activeItem.attr('data-value'));
        });

        $(this.selector).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
        });
    }

    changeValue(type, value) {
        if (type === 'products') {
            this.selectedProduct = value;
        } else if (type === 'delivery') {
            this.selectedDelivery = value;
        }

        this.toggleStoreSelect();
    }

    toggleStoreSelect() {
        if (this.selectedDelivery === 'Pickup') {
            $('.store-products__stores').addClass('active');

            if (this.selectedStore !== null) {
                $(this.submitBtn).attr('disabled', false);
            } else {
                $(this.submitBtn).attr('disabled', true);
            }
        } else {
            $('.store-products__stores').removeClass('active');
            $(this.submitBtn).attr('disabled', false);
        }
    }

    storeSelector() {
        $('.store-products__stores-title').on('click', (el) => {
            $(el.target).next().slideToggle(200);
        });

        $('.store-products__stores-item').on('click', (el) => {
            $(el.target).parent().slideUp(200).prev()
                .text($(el.target).text());
            this.selectedStore = $(el.target).attr('data-url');
            this.toggleStoreSelect();
        });

        $(document).mouseup((e) => {
            const container = $('.store-products__stores');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.store-products__stores-items').slideUp(200);
            }
        });
    }

    submitBtnEvent() {
        $(this.submitBtn).on('click', () => {
            if (this.selectedDelivery === 'Pickup') {
                window.open(this.selectedStore, '_blank');
            } else if (this.selectedDelivery === 'Home Delivery') {
                $('.product-popup-overlay').addClass('active');
                $(`.product-popup[data-value="${this.selectedProduct}"]`).addClass('active');
                ScreenLock.lock();
            }
        });
    }

    heroBtnEvent() {
        $(`${this.heroBtn}[href^="#"]`).on('click', (e) => {
            e.preventDefault();
            const hrefId = String($(e.currentTarget).attr('href'));

            if (hrefId === '#home-delivery') {
                $(`${this.selector}[data-type="delivery"]`).slick('slickGoTo', 0);
            } else if (hrefId === '#pickup') {
                $(`${this.selector}[data-type="delivery"]`).slick('slickGoTo', 1);
            }
            $('html, body').animate({
                scrollTop: $(e.currentTarget).parents('section').next().offset().top,
            }, 600);
        });
    }
}

export default new StoreSlider();
